import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function CorporateCommercialLaw() {

  useEffect(() => {
    document.title = "Corporate Commercial Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="/corporate.webp"
              alt="Corporate and Commercial Law" 
              loading="lazy"
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
             We offer comprehensive legal services across diverse areas, including general corporate and regulatory advice, where we provide guidance on corporate compliance and regulations. Our expertise extends to drafting and reviewing commercial contracts such as partnership agreements and vendor contracts, along with offering strategic advice on optimal company structures. For businesses, we assist with company formation for Public and Private Limited Companies, One Person Companies, and Limited Liability Partnerships, ensuring compliance with legal requirements like Director Identification Numbers (DIN), Digital Signature Certificates (DSC), and the drafting of Memorandum and Articles of Association. We also provide ongoing compliance services, covering monthly, quarterly, and annual filings.</p>

            <div className="button-container">
              <Link to="/contact">
                <button className="contact-button">Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default CorporateCommercialLaw;
